import React from "react"

import {FieldTableCellProps, getTableCellStyle} from "../../../../../render/table/table-cell"
import {ItemModelV2_CalculatedValues} from "../../../../../../model2/item2/calculated/@type"

// const debug = "FieldItemModelCalculatedSpentEstimate_TableCell"
const debug = false

export default function FieldItemModelCalculatedSpentEstimate_TableCell(props: FieldTableCellProps){

    let value = 0

    /*if (props.listItem.view.isCollapsed &&
        props.listItem.calculated.estimated.total &&
        props.listItem.calculated.estimated.total != props.listItem.calculated.estimated.own) {
        value = Math.floor(props.listItem.calculated.reported.total * 100 / props.listItem.calculated.estimated.total)
    } else if (props.listItem.calculated.estimated.own) {
        value = Math.floor(props.listItem.calculated.reported.own * 100 / props.listItem.calculated.estimated.own)
    } else {
        //  ????
    }*/

    const calculatedValues: ItemModelV2_CalculatedValues | undefined = props.listItem.calculated.dataByAggregateFunction[props.field.fieldId as keyof {}]?.[props.column.aggregateFunction!]
    const ownValue = calculatedValues?.own || props.field.getViewValue(props.listItem.item)

    debug && console.log(debug, "render", calculatedValues)

    if (props.listItem.view.isCollapsed && calculatedValues && !!calculatedValues?.total?.value && calculatedValues.total.value != calculatedValues.own) {
        value = Math.floor(calculatedValues.total.value)
    } else if (ownValue > 0) {
        value = Math.floor(ownValue)
    }

    const excess = value > 100
    const progressLine = excess ? Math.floor(100 * (100 / value)) : value;
    const progressClasses = Classes("ui5-progress", "in-ui5-field", {
        'excess-v2': excess,
    });

    const style = getTableCellStyle(props)
    const showProgress = !!style.width && (style.width as number) > 100

    return (
        <div className="cell-flex ui5-txt-less-important-small" style={getTableCellStyle(props)}>
            {!!value && (
                <div className={Classes(progressClasses, showProgress ? "" : "flex-row-center-center")}>
                    {showProgress && (
                        <div className="progress-bg">
                            <div className="progress-line" style={{width: '{0}%'.f(progressLine)}}/>
                        </div>
                    )}

                    <div className="progress-label ui5-txt-less-important-small percentage txt-truncate">
                        {"{0}%".f(value)}
                    </div>
                </div>
            )}
        </div>
    )
}



